// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-sH5","type":"styles_type___b1mt","choices":"styles_choices__19kJx"};